import React from 'react';
import { Link } from 'react-router-dom';
import './CategoryCard.css'; 

function CategoryCard({ category }) {
  return (
    <div className="category-card">
      <Link to={`/category/${category.categoryID}`} className="category-card-link">
        <div className="category-card-image-container">
          <img
            src={`${category.imageFileName}`}
            alt={category.name}
            className="category-card-image"
            loading="lazy"
          />
          <div className="category-card-overlay">
            <h3 className="category-card-title">{category.name}</h3>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default CategoryCard;